.container {
    border-radius: 12px;
    height: 100%;
    width: 100%;
    background-color: var(--static-background-standard);
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.title {
    position: absolute;
    left: 20px;
    top: 20px;
    font-size: var(--font-size-small);
    font-weight: 500;
    color: var(--static-text-standard);
}

.buyCost {
    font-size: 2rem;
    font-weight: 600;
    color: var(--static-text-standard);
}

.editButton {
    position: absolute;
    right: 20px;
    top: 16px;
    min-height: 0;
    padding-left: 8px;
    padding-right: 8px;
}

